const rankingItems = [
  { rank: 1, title: '流浪地球3', type: '科幻', hot: '本周最热', trendIcon: 'ri-arrow-up-fill' },
  { rank: 2, title: '长安十二时辰', type: '古装', hot: '飙升榜第一', trendIcon: 'ri-arrow-up-fill' },
  { rank: 3, title: '消失的她', type: '悬疑', hot: '评分9.2', trendIcon: 'ri-arrow-up-fill' },
  { rank: 4, title: '热辣滚烫', type: '喜剧', hot: '新片上线', trendIcon: 'ri-add-fill' },
  { rank: 5, title: '三体·剧版', type: '科幻', hot: '持续霸榜', trendIcon: 'ri-subtract-fill' },
  { rank: 6, title: '孤注一掷', type: '犯罪', hot: '热议不断', trendIcon: 'ri-arrow-up-fill' },
];

const rankMedals = ['🥇', '🥈', '🥉'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              影视热榜
            </h2>
            <p className="text-foreground-500 text-sm">全网最热影片实时排行，看看大家都在看什么</p>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-lg font-heading bg-background-100 ${
                  item.rank <= 3 ? 'text-accent-500' : 'text-foreground-400'
                }`}>
                  {item.rank <= 3 ? (
                    <span className="text-xl">{rankMedals[item.rank - 1]}</span>
                  ) : (
                    <span>{String(item.rank).padStart(2, '0')}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground-900 text-sm truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-400">{item.type}</span>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                <span className="w-6 h-6 flex items-center justify-center text-accent-500">
                  <i className={`${item.trendIcon} text-sm`}></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}